import React from "react"
import PropTypes from "prop-types"
import { Route, Redirect } from "react-router-dom"
import { TOKEN_PREFIX } from "helpers/api_methods"

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (isAuthProtected && !localStorage.getItem(TOKEN_PREFIX)) {
        return (
          <Redirect to={{ pathname: "/", state: { from: props.location } }} />
        )
      }
      return (
        <Layout>
          <Component {...props} />
        </Layout>
      )
    }}
  />
)

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
}

export default Authmiddleware
